import React from 'react';
import type { Props } from './types';

const DynamicCoverageModalLazy = React.lazy(
  () => import(/* webpackChunkName: "BuyersProtectionDynamicCoverageModal" */ './DynamicCoverageModal'),
);

const Modal = ({ onClose }: Props) => {
  return (
    <React.Suspense fallback={null}>
      <DynamicCoverageModalLazy onClose={onClose} />
    </React.Suspense>
  );
};

export default Modal;
